<template>
    <div>
        <md-field>
            <label>触发方式</label>
            <md-select v-model="trigger" name="trigger" id="trigger">
                <!-- <md-option value="Auto">自动</md-option> -->
                <md-option value="Click">点击目标</md-option>
                <!-- <md-option value="Pattern">属性改变</md-option> -->
                <!-- <md-option value="UIButton">UI点击</md-option> -->
                <md-option value="HandTrigger">手动触发</md-option>
                <md-option value="selectTrigger">选项节点</md-option>
                <md-option value="ChooseModel"> 模型选择</md-option>
                <md-option value="OpenUi"> 打开页面</md-option>
                <md-option value="taskSelect">任务选择</md-option>
                <md-option value="TaskConditionExam">考试任务</md-option>
                <md-option value="TaskConditionExamSettle">考核结算</md-option>
            </md-select>
        </md-field>



         <div v-show="trigger=='TaskConditionExam'">
          <span style="font-size:20px;padding: 5px;color:green; cursor: pointer;" @click="examArrsFn"
                  title="添加任务选择界面">+</span>
                  <div v-for="item in examArrs" :key="item.id">
                        <md-field>
                            <md-input type="text" v-model="item.question" style="text-indent: 4px" placeholder="请输入问题"></md-input>
                        </md-field> 
                         <div v-for="items in item.checkBox" :key="items.id">
                           <md-checkbox v-model="items.isCheck"   style="margin-right: 2px !important; vertical-align: middle">{{ items.name }}</md-checkbox> 
                           <md-field style="display: inline-block; width: 72% !important">
                                <md-input type="text" v-model="items.value" style="text-indent: 4px" placeholder="请输入"></md-input>
                            </md-field>
                          </div>
            
                              <div>答案:</div>
                              <md-radio  v-for="(items, index) in item.checkBoxCondition"  :key="items" v-model="item.answer"   :value="items">{{ items }}</md-radio> 
                      
                        
                          <!-- <md-field v-for="(items, index) in item.checkBoxCondition" :key="index">
                             <label>答案:</label>
                              <md-radio   v-model="item.answer" :value="items">{{ items }}</md-radio> 
                          </md-field> -->
                        
                  </div>
              
                <!-- chooseA:'',
                chooseB:'',
                chooseC:'',
                chooseD:'', -->

         </div>

         <div v-show="trigger=='TaskConditionExamSettle'">


          <md-field>
            <label>考核结算</label>
            <md-select v-model="ExamSettle" name="ExamSettle" id="ExamSettle">
                <md-option value="SettleType_Activity">教学活动评估</md-option>
                <md-option value="SettleType_Task">教育完结评估</md-option>

            </md-select>
        </md-field>


          </div>



            <v-autocomplete v-if="trigger === 'Click'" @change="checkNode"  v-model="triggerClickTarget"  :items="nodelDataList" item-text="name" itemprop="key"
            label="节点搜索"></v-autocomplete>
            <div v-if="trigger === 'Click' || trigger === 'PageClick'" style="max-height: 300px;overflow: auto;" id="triggerTreeBody">
                <Tree :setting="setting" :nodes="treeData" @onCreated="handleCreated" ref="tree" class="md-tree" />
            </div>



        <v-select v-if="trigger === 'PageClick'" :items="currentPageList" item-value="id" item-text="name"
            v-model="meta.pageId" label="选择界面"></v-select>
        <v-select v-if="trigger === 'PageClick' && meta.pageId" :items="currentPageInsList" item-value="key" item-text="name"
            v-model="meta.pageInsKey" label="选择页面"></v-select>

        <v-treeview
            v-if="trigger === 'PageClick'" 
            activatable
            @update:active="selectUiComponent"
            :items="uiPageTree"
        ></v-treeview>




        <div v-show="tiggerFlag">
          <v-autocomplete  @change="checkNode" :items="nodelDataList"  v-model="filterDataTigger"  item-text="name" itemprop="key"
            label="节点搜索"></v-autocomplete>
            <div  style="max-height: 300px;overflow: auto;" id="triggerTreeBody">
                <Tree :setting="setting" :nodes="treeData" @onCreated="handleCreated" ref="tree" class="md-tree" />
            </div>



        <v-select :items="currentPageList" item-value="id" item-text="name"
            v-model="meta.pageId" label="选择界面"></v-select>
        <v-select v-if="meta.pageId" :items="currentPageInsList" item-value="key" item-text="name"
            v-model="meta.pageInsKey" label="选择页面"></v-select>

        <v-treeview 
            activatable
            @update:active="selectUiComponent1"
            :items="uiPageTree"
        ></v-treeview>
        </div>


        <md-field v-if="trigger === 'Pattern'">
            <label>属性列表</label>
            <md-select v-model="meta.prop" name="prop" id="prop">
                <md-option value="string">字符串</md-option>
                <md-option value="bool">布尔值</md-option>
            </md-select>
        </md-field>
        <md-field v-if="trigger === 'Pattern'">
            <label>属性值</label>
            <md-input v-model="meta.propValue" type="text"> </md-input>
            <span class="md-helper-text">请输入要改变到的属性值</span>
        </md-field>
        <md-field v-if="trigger === 'UIButton'">
            <label>按钮</label>
            <md-select v-model="meta.btn" name="btn" id="btn">
                <md-option value="formSubmit">表单提交</md-option>
                <md-option value="btnOk">确认</md-option>
                <md-option value="btnCancel">取消</md-option>
                <md-option value="devLib">点击设备库</md-option>
                <md-option value="miniMap">点击小地图</md-option>
                <md-option value="openUi">打开UI</md-option>
                <md-option value="closeUi">关闭UI</md-option>
            </md-select>
        </md-field>
        <md-field v-if="trigger === 'UIButton'">
            <div>
                <v-btn color="success" small @click.stop="showAttachForm">添加</v-btn>
                <v-data-table no-data-text="暂无附加信息" :headers="headers" :items="appendInfo" hide-default-footer
                    class="paginated-table table-striped table-hover">
                    <template v-slot:item.option="{ item, index }">
                        <v-btn icon color="error" @click.native="handleDelete(index)" small>
                            <v-icon small>mdi-close</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </div>
            <v-dialog v-model="showAttachDialog" hide-overlay max-width="600px">
                <v-card>
                    <v-card-title class="green--text">
                        <h4 class="text-h5">附加信息</h4>
                    </v-card-title>
                    <v-card-text>
                        <v-text-field v-model="appendForm.appendInfo" label="内容" hint="请输入附加信息内容"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" small @click="handleAttachConfirm">确 定</v-btn>
                        <v-btn color="gray" small @click="showAttachDialog = false">关 闭</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </md-field>
        <md-field v-if="trigger === 'devInstall'">
            <label>载体</label>
            <md-input v-model="meta.supportInstallMetaName" type="text"> </md-input>
            <span class="md-helper-text">请输载体设备名称</span>
        </md-field>
        <md-field v-if="trigger === 'devInstall'">
            <label>设备</label>
            <md-input v-model="meta.installMetaName" type="text"> </md-input>
            <span class="md-helper-text">请输入要安装的设备名称</span>
        </md-field>
        <md-field v-if="trigger === 'devInstall'">
            <div class="md-layout">
                <div class="md-layout-item md-size-20 md-small-size-100">
                    <label style="padding-top: 5px">是否销毁</label>
                </div>
                <div class="md-layout-item md-size-80 md-small-size-100">
                    <md-switch v-model="meta.isDestroy"></md-switch>
                </div>
            </div>
        </md-field>
        <md-field v-if="trigger === 'devInstall'">
            <label>延迟销毁时间</label>
            <md-input v-model="meta.delay" type="text"> </md-input>
            <span class="md-helper-text">请输入延迟销毁时间</span>
        </md-field>
        <md-field v-if="trigger === 'ExamTrigger'">
            <label>考题</label>
            <md-input v-model="meta.ExamTrigger" type="text"> </md-input>
            <span class="md-helper-text">考题</span>
        </md-field>
        <md-field v-if="trigger === 'ExamTrigger'">
            <label>选项A</label>
            <md-input v-model="meta.choiceA" type="text"> </md-input>
            <span class="md-helper-text">请输入选项A</span>
        </md-field>
        <md-field v-if="trigger === 'ExamTrigger'">
            <label>选项B</label>
            <md-input v-model="meta.choiceB" type="text"> </md-input>
            <span class="md-helper-text">请输入选项B</span>
        </md-field>
        <md-field v-if="trigger === 'ExamTrigger'">
            <label>选项C</label>
            <md-input v-model="meta.choiceC" type="text"> </md-input>
            <span class="md-helper-text">请输入选项C</span>
        </md-field>
        <md-field v-if="trigger === 'ExamTrigger'">
            <label>选项B</label>
            <md-input v-model="meta.choiceD" type="text"> </md-input>
            <span class="md-helper-text">请输入选项D</span>
        </md-field>
        <md-field v-if="trigger === 'ExamTrigger'">
            <label>标准答案</label>
            <md-input v-model="meta.answer" type="text"> </md-input>
            <span class="md-helper-text">请输入标准答案</span>
        </md-field>
    </div>
</template>
<script>
import Tree from "vue-giant-tree";
import { mapState, mapGetters } from "vuex";
import { allInterfacePage } from "@/api/interface/interface_page";
// let ztreeObj = null;
import { innerAction } from "../../SystemAction";
import { sceneAction } from "../../SceneAction";
import { findTypeListBySceneId } from "@/api/device";
import { uuid } from '@antv/x6/lib/util/string/uuid';
let ztreeObj = {};
let dataMap = {};
let uiPageExtIdMap = {};
const systemInnerAction = innerAction
  .flatMap((item) => item.action_list)
  .map((item) => {
    item.type = "system_inner";
    return item;
  });

const sceneInnerAction = sceneAction
  .flatMap((item) => item.action_list)
  .map((item) => {
    item.type = "system_inner";
    return item;
  });

const defaultActionList = [].concat(systemInnerAction, sceneInnerAction);
const defaultActionMap = defaultActionList.reduce((pre, next) => {
  pre[next.id] = next;
  return pre;
}, {});

const castDataFunc = (pageData = {}, map = {}) => {
  let { cId, children, componentName, props } = pageData;
  let xField = pageData['x-field']
  children = children ?? [];
  let arr = children.map(node => castDataFunc(node, map));

  cId = componentName === 'Root' ? 0 : cId;

  let name;
  if (xField !== undefined && xField.name) {
    name = xField.name;
  } else if (props !== undefined && props.title) {
    name = props.title;
  } else {
    name = componentName;
  }

  if (xField !== undefined && xField.extendedPropertiesId) {
    map[cId] = xField.extendedPropertiesId;
  }

  return {
    id: cId,
    name,
    children: arr
  }
}

export default {
    name: "Trigger",
    props: {
        // uiPageMap: {
        //     type: Object,
        //     default: () => {}
        // },
        tiggerFlag:{
          type: Boolean,
          default:false
        }
    },
    components: {
        Tree,
    },
    computed: {
        ...mapGetters(['treeData', 'treeDataMap']),
        ...mapState({
            taskInfo: (state) => state.task.checkTaskInfo,
        }),
    },
    data() {
        return {
            ExamSettle:'',
            examArrs:[ ],
            triggerClickTarget:"",
            filterDataTigger:"",
            nodelDataList: [],
            appendInfo: [],
            headers: [
                { text: '附加信息', align: 'center', value: 'appendInfo' },
                { text: '编辑', align: 'center', value: 'option', width: "100px" }
            ],
            meta: {},
            trigger: "",
            showAttachDialog: false,
            appendForm: {},
            setting: {
                check: {
                    //树是否带复选框或者单选框
                    enable: false,
                },
                data: {
                    simpleData: {
                        //是否使用简单数据模式
                        enable: true,
                        //树节点id，一般是后台数据库主键
                        idKey: "id",
                        //父级id
                        pIdKey: "pid",
                        rootPId: "0",
                    },
                },
                //ztree回调函数
                callback: {
                    //树选择事件
                    onClick: this.treeNodeClick,
                },
            },
            currentPageList: [],
            currentPageInsList: [],
            uiPageTree: []
        };
    },
    watch: {
        meta: {
            deep: true,
            handler: function (val) {
                // this.type = this.meta.type;
                delete this.meta.trigger
                const triggerForm = Object.assign({
                    type: this.meta.type,
                    trigger: this.trigger,
                }, this.meta)
                if (val.pageId) {
                    allInterfacePage({ parentId: val.pageId }).then(res => {
                        this.currentPageInsList = res.data.rows;
                    })
                }
                if (val.pageInsKey) {
                  const insPage = this.currentPageInsList.find(item => item.key === val.pageInsKey)
                  if(insPage){
                    let data = JSON.parse(insPage.pageJSON);
                    this.uiPageTree = [castDataFunc(data, this.uiPageMap)];
     
                  }
               
              
                }
                this.$emit("updateTrigger", triggerForm);
            },
        },
        trigger(val) {
            this.$emit("updateTrigger", {
                type: this.meta.type,
                trigger: val,
                deviceId: this.meta.deviceId,
                deviceName: this.meta.deviceName,
            });
            this.ExamSettle =""
        },
        'examArrs':{
           handler(news){
            news&&news.forEach(element => {
              element.checkBox.forEach(items=>{
                  var parse = items.name
                  element[parse] = items.value;
              })
              let parArr =  news.map((item)=>{
                     let  {
                          answer,
                          chooseA,
                          chooseB,
                          chooseC,
                          chooseD,
                          examType,
                          question
                     } = item;
                     return {
                          answer,
                          chooseA,
                          chooseB,
                          chooseC,
                          chooseD,
                          examType,
                          question
                     }
              })
              this.$emit("setExamArr", parArr);
              
            });

           },
           deep:true
        },
        ExamSettle:{
          handler(news){
              this.$emit("setExamSettle",news)
          }
           
        }
    },
    mounted(){
      this.getList()
    },
    methods: {

      //添加考试任务
      examArrsFn(){
        this.examArrs.push({
                examType:'ExamType_Option',
                question:'',
                chooseA:'',
                chooseB:'',
                chooseC:'',
                chooseD:'',
                answer:'',
                checkBox: [
                  {
                    id: "1",
                    isCheck: false,
                    value: "",
                    name: "chooseA",
                  },
                  {
                    id: "2",
                    isCheck: false,
                    value: "",
                    name: "chooseB",
                  },
                  {
                    id: "3",
                    isCheck: false,
                    value: "",
                    name: "chooseC",
                  },
                  {
                    id: "4",
                    isCheck: false,
                    value: "",
                    name: "chooseD",
                  },
                ],
                checkBoxCondition: [
                "A",
                "B",
                "C",
                "D"],
                id:uuid()
        })

      },
      getList() {
      // const projectId = this.taskInfo.project;
      const courseId = this.taskInfo.course?this.taskInfo.course:'';
      findTypeListBySceneId({
        // sceneId: this.taskInfo.taskEditor,
        // type: "editor",
        courseId,
      }).then((res) => {
        this.list = res.data;

        let extMap = {};
        let uiPageMap = {};

        this.actionMap = res.data.reduce((pre, next) => {
          // 获取类型的动作列表
          pre[next.structId] = next.deviceTypeInfo
            ? next.deviceTypeInfo.actions
            : [];
          // 记录类型id
          pre[next.structId] = pre[next.structId].map((item) => {
            item._id = next.deviceTypeInfo._id;
            return item;
          });
          // 拼接默认的系统动作
          pre[next.structId] = pre[next.structId].concat(defaultActionList);

          // 根据结构id记录属性列表
          extMap[next.structId] = next.deviceTypeInfo
            ? next.deviceTypeInfo.extended_properties
            : [];
          uiPageMap[next.structId] = next.deviceTypeInfo
            ? next.deviceTypeInfo.interface
            : [];
          return pre;
        }, {});
        this.extMap = extMap;
        this.uiPageMap = uiPageMap;

        if (this.form && this.form.structId) {
          this.actionList =
            this.actionMap[this.form.realStructId] ?? defaultActionList;   
        }
   
        res.data.reduce((pre, next) => {
          pre[next.structId] = next;
          return pre;
        }, dataMap);
      });
    },
        selectUiComponent(e) {
            const id = e.join();
            this.meta.checkComponentId = id;
            this.meta.trigger = this.trigger  
            this.$emit("updateTrigger", this.meta);
        },

        selectUiComponent1(e) {
            const id = e.join();
            this.meta.checkComponentId = id;
          
            this.$emit("updateTrigger", this.meta);
        },
        handleAttachConfirm() {
            const arr = this.meta.appendInfo ?? [];
            arr.push(this.appendForm);
            this.appendInfo.push(this.appendForm);
            this.meta.appendInfo = this.appendInfo;
            this.showAttachDialog = false;
            this.$emit("updateTrigger", Object.assign({
                type: this.meta.type,
                trigger: this.trigger,
            }, this.meta));
        },
        showAttachForm() {
            this.appendForm = {};
            this.showAttachDialog = true;
        },
        handleDelete(index) {
            this.appendInfo.splice(index, 1);
            this.meta.appendInfo = this.appendInfo;
            this.$emit("updateTrigger", Object.assign({
                type: this.meta.type,
                trigger: this.trigger,
            }, this.meta));
        },
        getData() {
            const data = this.meta;
            return Object.assign({ trigger: this.trigger }, data)
        },
        init(form) {
            this.meta = Object.assign({}, form);
            this.trigger = form.trigger ?? "";
            this.appendInfo = form.appendInfo ?? [];
            if(form.trigger!==''){ 
             if(form.trigger=="HandTrigger"){

              return 
             }
             this.handleNodeAutoFocus()
              
            }
        },
        handleCreated(obj) {
            ztreeObj = obj;
            this.handleNodeAutoFocus()
        },
        handleNodeAutoFocus() {
            if (!ztreeObj) return;
            let uuuid = this.meta.deviceId
            if(ztreeObj){
              let nodes = ztreeObj.getNodes()
            console.log('nodes :>> ', nodes);
            if(nodes){
              let setModel = (l, arr = []) => {
                return l.flatMap((v) => {
                    if (v.id === uuuid) {
                        let tId = v.tId

                        ztreeObj.refresh()

                        let nodeList = ztreeObj.getNodesByParam('id', uuuid) //模糊搜索
                        if (nodeList[0]) {
                            let parentList = ztreeObj.getNodesByParam('id', nodeList[0].pid)
                            if (parentList[0]) {
                                ztreeObj.expandNode(parentList[0], true, false, false)
                            }
                        }
                        this.$nextTick(() => {
                            let dom = document.getElementById(tId + '_a')
                            if (dom) {
                                dom.click()
                            }
                        })
                        // ztreeObj.checkNode(v, true);
                    }
                    const useArr = [].concat(arr);
                    useArr.push(v.name)

                    const obj = {
                        key: v.id,
                        name: useArr.join('/'),
                        tId: v.tId
                    }


                    if (v.children && v.children.length !== 0) {
                        return [obj].concat(setModel(v.children, useArr))
                    }
                    return [obj]
                })
            }
            this.nodelDataList = setModel(nodes)
            }

            }
       
 
        },
        treeNodeClick(ztreeObj, treeId, treeNode) {
          // console.log(treeNode)
            const treeNodeMap = this.treeDataMap;
            // console.log(treeNodeMap)
            let node = treeNodeMap[treeNode.id] ?? {};
            this.meta.deviceId = treeNode.id;
            this.meta.deviceName = node.targetPath;

            if(this.uiPageMap){
              this.currentPageList = this.uiPageMap[treeNode.id] ?? [];
              this.$emit("updateTrigger", Object.assign({
                type: this.meta.type,
                trigger: this.trigger,
            }, this.meta));
             return 
            }
            this.$emit("updateTrigger", Object.assign({
                type: this.meta.type,
                trigger: this.trigger,
            }, this.meta))

    
        },
        checkNode(e) {
            const data = this.nodelDataList.find(item => item.name === e);
            const uuuid = data.key;
            ztreeObj.refresh()
           

            let nodeList = ztreeObj.getNodesByParam('id', uuuid) //模糊搜索
            if (nodeList[0]) {
                let parentList = ztreeObj.getNodesByParam('id', nodeList[0].pid)
                if (parentList[0]) {
                    ztreeObj.expandNode(parentList[0], true, false, false)
                }
            }

            console.log(this.$refs.treeBody, '看下内容')


            this.$nextTick(() => {
                let dom = document.getElementById(data.tId + '_a')
                let bodyDom = document.getElementById('triggerTreeBody');
                bodyDom.scrollTop = dom.offsetTop;
                if (dom) {
                    dom.click()
                }
            })
         
        }
    },
};
</script>
